// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Step02__pc_only___1YoHa","sp_only":"Step02__sp_only___3o2gp","container":"Step02__container___SZSJa","header":"Step02__header___29Geg"};